module.exports = __webpack_public_path__ + "static/media/Cooperationbg@2x.8cf5ff2a.png";